import * as Yup from "yup";
import { useTranslation } from "react-i18next";

export function ProceduresValidationSchema() {
  const { t } = useTranslation();

  const validation = Yup.object().shape({
    name: Yup.string()
      .min(3, t("LABEL.min"))
      .max(50, t("LABEL.max"))
      .required(t("LABEL.required")),
    value: Yup.string().required(t("LABEL.required")),
    // time: Yup.string().required(t("LABEL.required")),
    // exam: Yup.string().required(t("LABEL.required")),
    // covenant: Yup.string().required(t("LABEL.required")),
  });

  return validation;
}
